// NossosSites.js — os outros sites da Insigne na faixa laranja do cabeçalho
// (18/10/2026). No mesmo desenho do resto da faixa: ícone + texto em
// maiúsculas, separados por "|", como o telefone, o FAQ e a ajuda do lado
// esquerdo. O site atual não aparece: a marca do cabeçalho já diz onde se está.
// A mesma peça existe no site principal e no do Congresso.
import React, { Fragment } from "react";
import { OUTROS_SITES } from "../../config/sites";

const NossosSites = ({ className = "" }) => (
  <nav aria-label="Outros sites da Insigne" className={"items-center gap-3 md:gap-5 " + className}>
    {OUTROS_SITES.map((s, i) => (
      <Fragment key={s.chave}>
        {i > 0 && <span className="opacity-50">|</span>}
        <a href={s.url} className="flex items-center gap-2 !text-ink-fixed">
          <i className={"bi " + s.icone} aria-hidden="true" />
          {s.curto}
        </a>
      </Fragment>
    ))}
  </nav>
);

export default NossosSites;
